import React, { useState, useContext } from "react";
import coinVideo from "../../Images/formImages/coin.webm";
import { BureauContext } from "../Pages/HelloTradePage";
import { getIST } from "../BureauJourney/bureauUtils";
import { gatrack } from "../../utils"

import "../../CssFiles/form.css";
import BenefitsComponent from "../BureauJourney/Components/BenefitsComponent";
import ProcessComponent from "../BureauJourney/Components/ProcessComponent";
import FAQComponent from "../BureauJourney/Components/FAQComponent";
import safetyIcon from "../../Images/bureauImages/safetyIcon.png";
import bulb_icon from "../../Images/bureauImages/bulb_icon.png";
import headphone_icon from "../../Images/bureauImages/headphone_icon.png";
import personal_icon from "../../Images/bureauImages/personal_icon.png";
import FooterComponent from "./FooterComponent";
import axios from "axios";
import { writeLogs } from "../../utils";
const fullNameRegex = /^[A-Za-z\s]+$/;
const fullPanRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
const BusinessRegex = /^[a-zA-Z0-9. ]+$/;

function FormComponent() {
  const {
    setDisplayPage,
    setOtpScreen,
    userInfo,
    setUserInfo,
    phoneError,
    setPhoneError,
    defaultUserInfo,
    setDefaultUserInfo,
    token,
    gstAvailable,
  } = useContext(BureauContext);

  const [isChecked, setIsChecked] = useState(true);
  const [isValidName, setIsValidName] = useState(true);
  const [isValidPan, setIsValidPan] = useState(true);
  const [isValidMob, setIsValidMob] = useState(true);
  const [checkBoxWarning, setCheckBoxWarning] = useState(false);
  const [isValidDate, setIsValidDate] = useState(true);
  const [ageErr, setAgeErr] = useState(false);
  const [enteringPan, setEnteringPan] = useState(true);
  const [perPan, setPerPan] = useState(true);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    // setFormData({
    //     ...formData,
    //     [name]: type === "checkbox" ? checked : value,
    // });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log("Form Submitted", formData);
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    setIsValidName(fullNameRegex.test(value));
    setUserInfo((prevInfo) => ({ ...prevInfo, name: value }));
  };

  const handlePanChange = (e) => {
    const input = e.target;
    const cursorPosition = input.selectionStart;

    const value = e.target.value.trim().toUpperCase();
    const isValidSubstring = validatePanSubstring(value);

    setEnteringPan(isValidSubstring);

    if (value.length == 10) {
      checkValidPan(value);
    } else {
      if (isValidPan) {
        setIsValidPan(false);
      }
    }

    setUserInfo((prevInfo) => ({ ...prevInfo, pan: value }));

    input.setSelectionRange(cursorPosition, cursorPosition);
  };

  const handleMobChange = (e) => {
    const value = e.target.value;
    setUserInfo((prevInfo) => ({
      ...prevInfo,
      updatedMob: value,
      maskedMob: "",
    }));
    const isValidMobile = /^[0-9]{0,10}$/.test(value);
    setIsValidMob(isValidMobile);
    if (phoneError) {
      setPhoneError(false);
    }
  };

  const handleMobKey = (e) => {
    if (
      !/[0-9]/.test(e.key) &&
      e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "Enter"
    ) {
      e.preventDefault();
    }
  };

  const handleCheckClick = () => {
    setIsChecked((prevState) => {
      const newState = !prevState;
      console.log("setting isChecked to", newState);
      if (newState) {
        setCheckBoxWarning(false);
      }
      return newState;
    });
  };

  const handleOtpClick = () => {
    let valid = true;
    if (!userInfo.name || !isValidName) {
      setIsValidName(false);
      valid = false;
    }

    const splitName = userInfo.name.split(" ");
    
    const firstPart = splitName[0] || "";
    const lastPart = splitName[splitName.length - 1] || "";
    const secondPart = splitName.length > 2 ? splitName.slice(1, -1).join(" ") : "";

    setUserInfo((prevInfo)=>({...prevInfo, fn : firstPart, ln : lastPart, mn: secondPart}))

    if (!checkValidPan(userInfo.pan)) {
      setIsValidPan(false);
      valid = false;
    }

    if (!isValidMob || userInfo.updatedMob.length != 10) {
      setIsValidMob(false);
      valid = false;
    }

    if (!isChecked) {
      console.log(
        "Please check the declaration checkbox, currently checkbox is => ",
        isChecked
      );
      valid = false;
      setCheckBoxWarning(true);
    }

    // handleBureauConnect();

    if (valid) {
      const currentIST = getIST();
      setUserInfo((prevInfo) => ({ ...prevInfo, otpTime: currentIST }));
      handleBureauConnect();
      gatrack("HT Journey", "Valid Apply Now Click", "Form", userInfo.glid)
      // captureIntentClick()
    } else {
      gatrack("HT Journey", "Invalid Apply Now Click", "Form", userInfo.glid)
      console.log(
        "Please ensure all fields are valid and the checkbox is checked."
      );
    }
  };

  const handleApplyClick = () => {
    var host = window.location.hostname;

    if (host == "www.hellotrade.com") {
      var apiURL = "https://loans.indiamart.com/api/v1/captureClick";
    } else {
      var apiURL = "https://dev-loans.indiamart.com/api/v1/captureClick";
    }
    var inData = {
      glid: userInfo.glid,
      bname: userInfo.busiName,
      iname: userInfo.name,
      pan: userInfo.pan,
      dob: userInfo.dob,
      updatedMob: userInfo.updatedMob,
      loanamt: "NA",
      src: "HelloTrade",
    };

    var formData = new FormData();
    for (var key in inData) {
      formData.append(key, inData[key]);
    }

    axios({
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "x-api-key": '',
      },
      url: apiURL,
      data: formData,
      timeout: 2000,
    }).then(function (response) {
      //console.log(response.data);
      if (response.data.CODE == "200") {
        // setIsClickCapture(true);
      }
    });
    //console.log("User Info => ", userInfo);
  };

  const handleBureauConnect = () => {
    const host = window.location.hostname;

    const apiKey =
      host == "www.hellotrade.com"
        ? "98fdeef1a7c14ea3972320a6169838ce"
        : "e1a7232a8c5145b99d34135cefd1ad30";
    const customerId = userInfo.glid;

    const splitName = userInfo.name.split(" ");

    const firstPart = splitName[0] || "";
    const lastPart = splitName[splitName.length - 1] || "";
    const secondPart =
      splitName.length > 2 ? splitName.slice(1, -1).join(" ") : "";

    const firstName = firstPart;
    const middleName = secondPart;
    const lastName = lastPart;
    const phone = userInfo.updatedMob;

    //    const customerId = '192395864';
    //     const firstName = 'Aviral';
    //     const middleName = '';
    //     const lastName = 'Panwar';
    //     const phone = '7668945130';

    console.log(
      "In handle Bureau func id, fn, mn, ln, phone => ",
      customerId,
      firstName,
      middleName,
      lastName,
      phone
    );

    handleApplyClick();

    if (window.getBureauSession) {
      console.log("In getBureauSession");
      window
        .getBureauSession(
          apiKey,
          customerId,
          firstName,
          middleName,
          lastName,
          phone
        )
        .then((bureauSession) => {
          if (bureauSession) {
            //console.log("URl=> ", bureauSession);
            writeLogs(userInfo.glid, "NA", "NA","SUCCESS","BUREAU_SDK","200","NA","NA","NA","NA")
            setOtpScreen(bureauSession);
            setDisplayPage(2);
          } else {
            writeLogs(userInfo.glid, "NA", "NA","FAILURE","BUREAU_SDK","400","Not getting bureau session","NA","NA","NA")
            console.error("Not getting bureau session");
          }
        })
        .catch((error) => {
          setPhoneError(true);
          const errorDetails = error.response?.data || error.message || JSON.stringify(error);
          writeLogs(userInfo.glid, "NA", "NA","FAILURE","BUREAU_SDK","400",errorDetails,"NA","NA","NA")
          console.error("Session initiation error:", error);
        });
    }
  };

  const handleNameKey = (e) => {
    if (
      fullNameRegex.test(e.key) ||
      e.key === "Backspace" ||
      e.key === "Delete" ||
      e.key == " "
    ) {
      return;
    }
    e.preventDefault();
  };

  const handlePanKey = (e) => {
    const isAlphaNumeric = /^[a-zA-Z0-9]$/.test(e.key);

    if (
      !isAlphaNumeric &&
      e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "ArrowLeft" &&
      e.key !== "ArrowRight"
    ) {
      e.preventDefault();
    }
  };

  const checkValidPan = (value) => {
    if (
      value.length == 10 &&
      /[A-Z]/.test(value.charAt(3)) &&
      value.charAt(3) != "P"
    ) {
      if (perPan) {
        setPerPan(false);
      }
    } else {
      if (!perPan) {
        setPerPan(true);
      }
    }

    if (
      value.length == 10 &&
      value.charAt(3) == "P" &&
      fullPanRegex.test(value)
    ) {
      if (!isValidPan) {
        setIsValidPan(true);
      }

      if (!enteringPan) {
        setEnteringPan(true);
      }
      return true;
    }
    if (isValidPan) {
      setIsValidPan(false);
    }
    if (enteringPan) {
      setEnteringPan(false);
    }
    return false;
  };

  const validatePanSubstring = (value) => {
    const length = value.length;

    if (
      length >= 4 &&
      /[A-Z]/.test(value.charAt(3)) &&
      value.charAt(3) !== "P"
    ) {
      if (perPan) {
        setPerPan(false);
      }
      return false;
    } else {
      if (!perPan) {
        setPerPan(true);
      }
    }

    if (
      length === 1 ||
      length === 2 ||
      length === 3 ||
      length === 4 ||
      length == 5
    ) {
      return /^[A-Z]{0,5}$/.test(value);
    }

    if (length >= 6 && length <= 9) {
      return /^[A-Z]{5}[0-9]{0,4}$/.test(value);
    }

    if (length === 10) {
      return /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value);
    }

    return false; // Invalid length or condition
  };

  const handlePanInput = (e) => {
    const input = e.target;
    const start = input.selectionStart; // Capture the cursor position
    const end = input.selectionEnd;

    // Transform the input value to uppercase
    input.value = input.value.toUpperCase();

    // Restore the cursor position
    input.setSelectionRange(start, end);
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <>
      <div
        className="home form-parent"
        style={{
          backgroundImage: `url('https://loans.imimg.com/desktop_react/src/Images/newHomeImages/newFormBG_updated.png')`,
        }}
      >
        <div className="row">
          <div className="col-6 leftSide">
            <div>
              <div className="bg-text-parent">
                <div className="bg-text">
                  Your Business, Our Commitment: <br />{" "}
                  <span className="busi-grow">The Right Loan, Every Time.</span>
                </div>

                <div className="one-stop">
                  A one stop shop for all your business loan needs
                </div>

                <div className="loan-feature-box">
                  <div className="loan-feature">
                    <img src={bulb_icon} className="allIcons" />
                    <div className="feature-text">
                      Loans customised to your needs
                    </div>
                  </div>
                  <div className="loan-feature">
                    <img src={personal_icon} className="allIcons" />
                    <div className="feature-text">RBI approved lenders</div>
                  </div>
                  <div className="loan-feature">
                    <img src={headphone_icon} className="allIcons" />
                    <div className="feature-text">Unbiased service</div>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
          </div>
          <div className="col-6 rightSide">
            <div>
              <div className="form-card">
                <h3 className="form-heading">{
                  userInfo.busiName != "" &&
                  <h3 className="form-heading">Hi, {userInfo.busiName}</h3>
                }
                  {
                    userInfo.busiName == "" &&
                    <h3 className="form-heading">Please fill your details</h3>
                  }
                </h3>
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="fullName" className="form-label-new">
                      Full Name
                    </label>
                    <input
                      type="text"
                      id="fullName"
                      name="fullName"
                      value={userInfo.name}
                      className="form-control"
                      placeholder="Enter Your Name"
                      readOnly={
                        defaultUserInfo.name &&
                        defaultUserInfo.name.length > 0 &&
                        isValidName
                      }
                      onChange={handleNameChange}
                      onKeyDown={handleNameKey}
                      style={{
                        cursor:
                          defaultUserInfo.name &&
                          defaultUserInfo.name.length > 0 &&
                          isValidName
                            ? "not-allowed"
                            : "",
                      }}
                    />
                    {!isValidName && (
                      <div className="warning">Please Enter Valid Name</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="panNumber" className="form-label-new">
                      PAN Number
                    </label>
                    <input
                      type="text"
                      id="panNumber"
                      name="panNumber"
                      className="form-control"
                      placeholder="Enter Your PAN"
                      maxLength={10}
                      style={{
                        textTransform: "uppercase",
                        cursor:
                          defaultUserInfo.pan &&
                          defaultUserInfo.pan.length > 0 &&
                          isValidPan
                            ? "not-allowed"
                            : "",
                      }}
                      value={
                        defaultUserInfo.pan.length == 10
                          ? `${userInfo.pan[0]}***${userInfo.pan[3] || "*"}${
                              userInfo.pan[4] || "*"
                            }****${userInfo.pan[9] || "*"}`
                          : userInfo.pan
                      }
                      readOnly={
                        defaultUserInfo.pan &&
                        defaultUserInfo.pan.length > 0 &&
                        isValidPan
                      }
                      onChange={handlePanChange}
                      onKeyDown={handlePanKey}
                      onInput={handlePanInput}
                    />
                    {!enteringPan && perPan && (
                      <div className="warning">Please Enter Valid PAN No.</div>
                    )}
                    {!perPan && (
                      <div className="warning">
                        Please Enter Personal PAN No.
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="mobileNumber" className="form-label-new">
                      Mobile Number
                    </label>
                    <div className="form-group-inline">
                      <input
                        type="tel"
                        placeholder="Enter Mobile"
                        className="input-readonly form-control"
                        maxLength={10}
                        value={userInfo.maskedMob || userInfo.updatedMob}
                        readOnly={
                          defaultUserInfo.updatedMob &&
                          defaultUserInfo.updatedMob.length > 0 &&
                          isValidMob
                        }
                        onChange={handleMobChange}
                        onKeyDown={handleMobKey}
                        style={{
                          cursor:
                            defaultUserInfo.updatedMob &&
                            defaultUserInfo.updatedMob.length > 0 &&
                            isValidMob
                              ? "not-allowed"
                              : "pointer",
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      id="consent"
                      name="consent"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                      className="form-checkbox"
                    />
                    <label htmlFor="consent" className="form-checkbox-label">
                      I agree to HelloTrade's Privacy Policy and T&Cs.
                    </label>
                  </div>
                  {checkBoxWarning && (
                    <div className="warning">Click on the checkbox</div>
                  )}

                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {phoneError && (
                      <div className="warning">
                        Something went wrong. Please try again after sometime!
                      </div>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="form-btn"
                    onClick={handleOtpClick}
                  >
                    Apply Now
                  </button>
                </form>

                <div>
                  <div className="safety">
                    <img src={safetyIcon} />
                    <div id="safety-text">Your data is 100% safe & secure</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <BenefitsComponent />
      <ProcessComponent />
      <FAQComponent />
      <FooterComponent />
    </>
  );
}

export default FormComponent;
